import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import validate from 'validate.js';
import { DialogContentText, Grid } from '@mui/material';
import {
  DialogDefaultV2,
  InputV2,
  DefaultSelectV2,
  TrueFalseSelectV2,
  NumberInputV2,
} from '../../../components/v2';
import * as selectorsUsuarioDocumentos from '../../../store/usuarioDocumento/reducer';
import * as actionsUsuarioDocumentos from '../../../store/usuarioDocumento/actions';

const schema = {
  tipo: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  nome: { presence: { allowEmpty: false, message: 'é obrigatório' } },
  possuiValidade: { presence: { allowEmpty: false, message: 'é obrigatório' } },
};

const Formulario = ({ saveUsuarioDocumento, updateUsuarioDocumento, selectedUsuarioDocumento, findUsuarioDocumentoById, open, id, onClose, readOnly }) => {
  const [values, setValues] = useState({ tipo: 'DOCUMENTO', possuiValidade: 'true' });
  const [errors, setErrors] = useState({});
  const [openUpdateValidate, setOpenUpdateValidate] = useState(false);

  useEffect(() => {
    if (id) findUsuarioDocumentoById(id);
  }, [id, findUsuarioDocumentoById]);

  useEffect(() => {
    setValues({ tipo: 'DOCUMENTO', possuiValidade: 'true' });
  }, [open]);

  useEffect(() => {
    if (id && selectedUsuarioDocumento) {
      setValues(selectedUsuarioDocumento);
    }
  }, [id, selectedUsuarioDocumento]);

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const possuiValidade = values.possuiValidade === 'true' || values.possuiValidade === true;

  const onSave = () => {
    let schemaData = schema;
    if (!values.validadeEmAnos && possuiValidade) {
      schemaData = { ...schemaData, validadeEmAnos: { presence: { allowEmpty: false, message: 'é obrigatório' } } };
    }
    const erros = validate(values, schemaData);
    setErrors(erros);
    if (!erros) {
      if (values.id && possuiValidade) {
        setOpenUpdateValidate(true);
      } else {
        if (values.id) updateUsuarioDocumento(values, () => onCloseLocal(true));
        else saveUsuarioDocumento(values, () => onCloseLocal(true));
      }
    }
  };

  const onUpdateAfterModal = (updateAllValidates) => {
    setOpenUpdateValidate(false);
    updateUsuarioDocumento({ ...values, updateAllValidates }, () => onCloseLocal(true));
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    setValues({});
    onClose(isSave);
  };

  return (
    <>
      <DialogDefaultV2
        open={open}
        handlerCancel={() => onCloseLocal(false)}
        handlerConfirm={onSave}
        title="Documento / Certificado"
        confirmMessage="Salvar"
        maxWidth="md"
        fullWidth
        readOnly={readOnly}
      >
        <Grid container spacing={2}>
          <Grid size={{ md: 4, xs: 12 }}>
            <DefaultSelectV2
              label="Tipo"
              name="tipo"
              showEmpty={false}
              isRequired
              options={[
                { id: 'DOCUMENTO', nome: 'Documento' },
                { id: 'CERTIFICADO', nome: 'Certificado' },
              ]}
              onSelect={handleChange}
              value={values.tipo}
              disabled={readOnly}
            />
          </Grid>
          <Grid size={{ xs: 8 }}>
            <InputV2
              error={!!(errors && errors.nome)}
              isRequired
              label="Nome"
              name="nome"
              onChange={handleChange}
              value={values.nome || ''}
              disabled={readOnly}
            />
          </Grid>
          <Grid size={{ xs: 4 }}>
            <TrueFalseSelectV2
              label="Possui Validade"
              name="possuiValidade"
              showEmpty={false}
              isRequired
              onChange={handleChange}
              value={values.possuiValidade}
              disabled={readOnly}
            />
          </Grid>
          {possuiValidade && (
            <Grid size={{ xs: 4 }}>
              <NumberInputV2
                error={!!(errors && errors.validadeEmAnos)}
                isRequired={possuiValidade}
                label="Validade (em anos)"
                onChange={(valor) => setValues({ ...values, validadeEmAnos: valor })}
                value={values.validadeEmAnos}
                decimalScale={0}
                prefix=""
                thousandSeparator=""
                disabled={readOnly}
              />
            </Grid>
          )}
          <Grid size={{ xs: 12 }}>
            <InputV2
              label="Descrição"
              name="descricao"
              onChange={handleChange}
              value={values.descricao || ''}
              rows={4}
              multiline
              disabled={readOnly}
            />
          </Grid>
        </Grid>
      </DialogDefaultV2>

      <DialogDefaultV2
        open={openUpdateValidate}
        handlerCancel={() => onUpdateAfterModal(false)}
        handlerConfirm={() => onUpdateAfterModal(true)}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
        headerAction={[{ onClick: () => setOpenUpdateValidate(false), title: 'Cancelar', show: true }]}
      >
        <DialogContentText>
          <strong>Deseja atualizar a data de vencimento para todos os usuários que possuem esse documento/certificado?</strong>
          <br />
          Se a nova data for válida só para novos vínculos, você deve selecionar não.
        </DialogContentText>
      </DialogDefaultV2>
    </>
  );
};

const mapStateToProps = (state) => ({
  selectedUsuarioDocumento: selectorsUsuarioDocumentos.getSelectedUsuarioDocumento(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsUsuarioDocumentos }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
